"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.reflect.to-string-tag.js");
require("core-js/modules/es.string.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _reactCompoundSlider = require("react-compound-slider");
var _core = require("../../core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_1y2189tk2m() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Slider/SliderBase.tsx";
  var hash = "10941dc555ad3d6f1a642cd3c09df2d109ae15ab";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Slider/SliderBase.tsx",
    statementMap: {
      "0": {
        start: {
          line: 113,
          column: 21
        },
        end: {
          line: 117,
          column: 1
        }
      },
      "1": {
        start: {
          line: 115,
          column: 23
        },
        end: {
          line: 115,
          column: 35
        }
      },
      "2": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 17
        }
      },
      "3": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 130,
          column: 6
        }
      },
      "4": {
        start: {
          line: 147,
          column: 8
        },
        end: {
          line: 147,
          column: 18
        }
      },
      "5": {
        start: {
          line: 148,
          column: 23
        },
        end: {
          line: 148,
          column: 33
        }
      },
      "6": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 210,
          column: 6
        }
      },
      "7": {
        start: {
          line: 163,
          column: 12
        },
        end: {
          line: 169,
          column: 18
        }
      },
      "8": {
        start: {
          line: 174,
          column: 12
        },
        end: {
          line: 188,
          column: 18
        }
      },
      "9": {
        start: {
          line: 176,
          column: 16
        },
        end: {
          line: 186,
          column: 22
        }
      },
      "10": {
        start: {
          line: 194,
          column: 14
        },
        end: {
          line: 205,
          column: 20
        }
      },
      "11": {
        start: {
          line: 196,
          column: 18
        },
        end: {
          line: 203,
          column: 24
        }
      },
      "12": {
        start: {
          line: 213,
          column: 21
        },
        end: {
          line: 216,
          column: 3
        }
      },
      "13": {
        start: {
          line: 214,
          column: 4
        },
        end: {
          line: 214,
          column: 55
        }
      },
      "14": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 215,
          column: 30
        }
      },
      "15": {
        start: {
          line: 218,
          column: 21
        },
        end: {
          line: 221,
          column: 3
        }
      },
      "16": {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 219,
          column: 55
        }
      },
      "17": {
        start: {
          line: 220,
          column: 4
        },
        end: {
          line: 220,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 115,
            column: 13
          }
        },
        loc: {
          start: {
            line: 115,
            column: 23
          },
          end: {
            line: 115,
            column: 35
          }
        },
        line: 115
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 125,
            column: 3
          }
        },
        loc: {
          start: {
            line: 125,
            column: 39
          },
          end: {
            line: 131,
            column: 3
          }
        },
        line: 125
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 133,
            column: 2
          },
          end: {
            line: 133,
            column: 3
          }
        },
        loc: {
          start: {
            line: 133,
            column: 18
          },
          end: {
            line: 211,
            column: 3
          }
        },
        line: 133
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 162,
            column: 11
          },
          end: {
            line: 162,
            column: 12
          }
        },
        loc: {
          start: {
            line: 163,
            column: 12
          },
          end: {
            line: 169,
            column: 18
          }
        },
        line: 163
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 173,
            column: 11
          },
          end: {
            line: 173,
            column: 12
          }
        },
        loc: {
          start: {
            line: 174,
            column: 12
          },
          end: {
            line: 188,
            column: 18
          }
        },
        line: 174
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 175,
            column: 27
          },
          end: {
            line: 175,
            column: 28
          }
        },
        loc: {
          start: {
            line: 176,
            column: 16
          },
          end: {
            line: 186,
            column: 22
          }
        },
        line: 176
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 193,
            column: 13
          },
          end: {
            line: 193,
            column: 14
          }
        },
        loc: {
          start: {
            line: 194,
            column: 14
          },
          end: {
            line: 205,
            column: 20
          }
        },
        line: 194
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 195,
            column: 28
          },
          end: {
            line: 195,
            column: 29
          }
        },
        loc: {
          start: {
            line: 196,
            column: 18
          },
          end: {
            line: 203,
            column: 24
          }
        },
        line: 196
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 213,
            column: 21
          },
          end: {
            line: 213,
            column: 22
          }
        },
        loc: {
          start: {
            line: 213,
            column: 48
          },
          end: {
            line: 216,
            column: 3
          }
        },
        line: 213
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 218,
            column: 21
          },
          end: {
            line: 218,
            column: 22
          }
        },
        loc: {
          start: {
            line: 218,
            column: 48
          },
          end: {
            line: 221,
            column: 3
          }
        },
        line: 218
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 135,
            column: 28
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 135,
            column: 14
          },
          end: {
            line: 135,
            column: 28
          }
        }],
        line: 135
      },
      "1": {
        loc: {
          start: {
            line: 136,
            column: 6
          },
          end: {
            line: 136,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 136,
            column: 17
          },
          end: {
            line: 136,
            column: 22
          }
        }],
        line: 136
      },
      "2": {
        loc: {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 137,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 137,
            column: 15
          },
          end: {
            line: 137,
            column: 16
          }
        }],
        line: 137
      },
      "3": {
        loc: {
          start: {
            line: 139,
            column: 6
          },
          end: {
            line: 139,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 139,
            column: 26
          },
          end: {
            line: 139,
            column: 31
          }
        }],
        line: 139
      },
      "4": {
        loc: {
          start: {
            line: 140,
            column: 6
          },
          end: {
            line: 140,
            column: 30
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 140,
            column: 18
          },
          end: {
            line: 140,
            column: 30
          }
        }],
        line: 140
      },
      "5": {
        loc: {
          start: {
            line: 146,
            column: 6
          },
          end: {
            line: 146,
            column: 14
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 146,
            column: 13
          },
          end: {
            line: 146,
            column: 14
          }
        }],
        line: 146
      },
      "6": {
        loc: {
          start: {
            line: 167,
            column: 28
          },
          end: {
            line: 167,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 167,
            column: 28
          },
          end: {
            line: 167,
            column: 51
          }
        }, {
          start: {
            line: 167,
            column: 55
          },
          end: {
            line: 167,
            column: 64
          }
        }],
        line: 167
      },
      "7": {
        loc: {
          start: {
            line: 191,
            column: 9
          },
          end: {
            line: 208,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 191,
            column: 9
          },
          end: {
            line: 191,
            column: 20
          }
        }, {
          start: {
            line: 192,
            column: 10
          },
          end: {
            line: 207,
            column: 19
          }
        }],
        line: 191
      },
      "8": {
        loc: {
          start: {
            line: 214,
            column: 4
          },
          end: {
            line: 214,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 214,
            column: 4
          },
          end: {
            line: 214,
            column: 23
          }
        }, {
          start: {
            line: 214,
            column: 27
          },
          end: {
            line: 214,
            column: 54
          }
        }],
        line: 214
      },
      "9": {
        loc: {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 219,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 219,
            column: 23
          }
        }, {
          start: {
            line: 219,
            column: 27
          },
          end: {
            line: 219,
            column: 54
          }
        }],
        line: 219
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "10941dc555ad3d6f1a642cd3c09df2d109ae15ab"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1y2189tk2m = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1y2189tk2m();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* Currently this component is a styled wrapper around an external component.
  https://sghall.github.io/react-compound-slider/#/getting-started/tutorial
  If more complicated behavior is added in the future, more thorough tests should be added.
*/

var StyledSlider = (cov_1y2189tk2m().s[0]++, /*#__PURE__*/(0, _base["default"])(_reactCompoundSlider.Slider, process.env.NODE_ENV === "production" ? {
  target: "e1h601sb0"
} : {
  target: "e1h601sb0",
  label: "StyledSlider"
})("position:relative;height:", function (props) {
  cov_1y2189tk2m().f[0]++;
  cov_1y2189tk2m().s[1]++;
  return props.height;
}, "px;width:100%;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
var SliderBase = /*#__PURE__*/function (_React$Component) {
  _inherits(SliderBase, _React$Component);
  function SliderBase(props) {
    var _this;
    _classCallCheck(this, SliderBase);
    cov_1y2189tk2m().f[1]++;
    cov_1y2189tk2m().s[2]++;
    _this = _callSuper(this, SliderBase, [props]);
    _defineProperty(_assertThisInitialized(_this), "onUpdate", (cov_1y2189tk2m().s[12]++, function (update) {
      cov_1y2189tk2m().f[8]++;
      cov_1y2189tk2m().s[13]++;
      (cov_1y2189tk2m().b[8][0]++, _this.props.onUpdate) && (cov_1y2189tk2m().b[8][1]++, _this.props.onUpdate(update));
      cov_1y2189tk2m().s[14]++;
      _this.setState({
        update: update
      });
    }));
    _defineProperty(_assertThisInitialized(_this), "onChange", (cov_1y2189tk2m().s[15]++, function (values) {
      cov_1y2189tk2m().f[9]++;
      cov_1y2189tk2m().s[16]++;
      (cov_1y2189tk2m().b[9][0]++, _this.props.onChange) && (cov_1y2189tk2m().b[9][1]++, _this.props.onChange(values));
      cov_1y2189tk2m().s[17]++;
      _this.setState({
        values: values
      });
    }));
    cov_1y2189tk2m().s[3]++;
    _this.state = {
      update: props.values,
      values: props.values
    };
    return _this;
  }
  _createClass(SliderBase, [{
    key: "render",
    value: function render() {
      cov_1y2189tk2m().f[2]++;
      var _ref = (cov_1y2189tk2m().s[4]++, this.props),
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? (cov_1y2189tk2m().b[0][0]++, 'terracotta50') : _ref$color,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? (cov_1y2189tk2m().b[1][0]++, false) : _ref$disabled,
        _ref$height = _ref.height,
        height = _ref$height === void 0 ? (cov_1y2189tk2m().b[2][0]++, 4) : _ref$height,
        hideTooltip = _ref.hideTooltip,
        _ref$isCurrencyDispla = _ref.isCurrencyDisplay,
        isCurrencyDisplay = _ref$isCurrencyDispla === void 0 ? (cov_1y2189tk2m().b[3][0]++, false) : _ref$isCurrencyDispla,
        _ref$railColor = _ref.railColor,
        railColor = _ref$railColor === void 0 ? (cov_1y2189tk2m().b[4][0]++, 'neutrals40') : _ref$railColor,
        railsBackgroundOverride = _ref.railsBackgroundOverride,
        renderHandle = _ref.renderHandle,
        renderTrack = _ref.renderTrack,
        min = _ref.min,
        max = _ref.max,
        _ref$step = _ref.step,
        step = _ref$step === void 0 ? (cov_1y2189tk2m().b[5][0]++, 1) : _ref$step;
      var _ref2 = (cov_1y2189tk2m().s[5]++, this.state),
        values = _ref2.values;
      cov_1y2189tk2m().s[6]++;
      return /*#__PURE__*/_react["default"].createElement(StyledSlider, {
        mode: 3,
        height: height,
        domain: [min, max],
        step: step,
        disabled: disabled,
        values: values,
        onChange: this.onChange,
        onUpdate: this.onUpdate
      }, /*#__PURE__*/_react["default"].createElement(_reactCompoundSlider.Rail, null, function (_ref3) {
        var getRailProps = _ref3.getRailProps;
        cov_1y2189tk2m().f[3]++;
        cov_1y2189tk2m().s[7]++;
        return /*#__PURE__*/_react["default"].createElement(_core.Box, _extends({
          width: "100%",
          paddingTop: "".concat(height / 2, "px")
        }, getRailProps()), /*#__PURE__*/_react["default"].createElement(_core.Box, {
          borderRadius: "squared",
          height: height,
          background: (cov_1y2189tk2m().b[6][0]++, railsBackgroundOverride) || (cov_1y2189tk2m().b[6][1]++, railColor)
        }));
      }), /*#__PURE__*/_react["default"].createElement(_reactCompoundSlider.Handles, null, function (_ref4) {
        var activeHandleID = _ref4.activeHandleID,
          handles = _ref4.handles,
          getHandleProps = _ref4.getHandleProps;
        cov_1y2189tk2m().f[4]++;
        cov_1y2189tk2m().s[8]++;
        return /*#__PURE__*/_react["default"].createElement(_core.Box, null, handles.map(function (handle) {
          cov_1y2189tk2m().f[5]++;
          cov_1y2189tk2m().s[9]++;
          return /*#__PURE__*/_react["default"].createElement(_core.Box, {
            key: handle.id
          }, renderHandle({
            activeHandleID: activeHandleID,
            domain: [min, max],
            handle: handle,
            handleColor: color,
            hideTooltip: hideTooltip,
            isCurrencyDisplay: isCurrencyDisplay,
            getHandleProps: getHandleProps
          }));
        }));
      }), (cov_1y2189tk2m().b[7][0]++, renderTrack) && (cov_1y2189tk2m().b[7][1]++, /*#__PURE__*/_react["default"].createElement(_reactCompoundSlider.Tracks, {
        left: values.length <= 1,
        right: false
      }, function (_ref5) {
        var tracks = _ref5.tracks,
          getTrackProps = _ref5.getTrackProps;
        cov_1y2189tk2m().f[6]++;
        cov_1y2189tk2m().s[10]++;
        return /*#__PURE__*/_react["default"].createElement(_core.Box, null, tracks.map(function (_ref6) {
          var id = _ref6.id,
            source = _ref6.source,
            target = _ref6.target;
          cov_1y2189tk2m().f[7]++;
          cov_1y2189tk2m().s[11]++;
          return /*#__PURE__*/_react["default"].createElement(_core.Box, {
            key: id
          }, renderTrack({
            trackColor: color,
            source: source,
            target: target,
            getTrackProps: getTrackProps
          }));
        }));
      })));
    }
  }]);
  return SliderBase;
}((_react["default"].Component));
var _default = exports["default"] = SliderBase;